import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { matjungelenAmber, matjungelenDarkGreen } from "./colors";

export const WhiteTextField = styled(TextField)(({ theme }) => ({
  "& .MuiFilledInput-root": {
    background: matjungelenAmber,
    border: `1.5px solid ${matjungelenDarkGreen}`,
    borderRadius: "12px",
    "&:before, &:after": {
      display: "none",
    },
    "&:hover": {
      background: matjungelenAmber,
    },
    "&.Mui-focused": {
      background: matjungelenAmber,
      borderWidth: "2px",
    },
    "&.Mui-disabled": {
      background: matjungelenAmber,
    },
    "&.Mui-error": {
      borderColor: theme.palette.error.main,
    },
  },
  "& .MuiInputLabel-root": {
    color: matjungelenDarkGreen,
    "&.Mui-focused": {
      color: matjungelenDarkGreen,
    },
    "&.Mui-error": {
      color: theme.palette.error.main,
    },
  },
  "& .MuiSvgIcon-root": {
    color: matjungelenDarkGreen,
  },
}));
